/**
 *
 * @des 默认post get 方法简易包装
 *
 */

import axios from './config';

export const prefix = '/rest/';
export const shipperPrefix = '/shipper/api/';

// post默认请求
export function post(apiUrl, params) {
  return axios.post(apiUrl, params);
}

// get默认请求
export function get(apiUrl, params) {
  return axios.get(apiUrl, {
    params: params,
  });
}
